<template>
  <div>
    <pbas-data-table
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="contributions"
      :identifier="`employer${employerId}contributions`"
      @error="error = $event"
      :showSelect="false"
    ></pbas-data-table>

    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import getHeaders from "@/headers/EmployerContributions";
export default {
  props: ["employerId"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      provider: undefined,
      summaries: null,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", [ "planIdentity", "planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getEmployerContributionSummaries"]),
    loadPlanData() {
      let trackHours = this.planIdentity &&
            this.planIdentity.TrackHours;
      let url =
        "plans/" +
        this.selectedPlan.Id +
        "/employers/" +
        this.employerId +
        "/contributions";
      let headers = getHeaders(trackHours);
      this.provider = new ODataProvider(this.$axiosHttp, url, headers);
      // this.provider.filter = `EmployerId eq ${this.employerId}`;
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
  },
};
</script>
